import type { LogoutRepository } from '@/domains/auth/logout.repository';
import { useAuthStore } from '@/shared/stores';

/**
 * Implementación de logout solo local (sin petición al servidor)
 * Responsabilidad: Limpiar únicamente el estado del frontend
 *
 * Ventajas:
 * - Logout instantáneo (sin esperar respuesta del servidor)
 * - Funciona aunque el servidor esté caído
 * - Menos tráfico de red
 * - Experiencia de usuario más fluida
 */
class LogoutLocalRepository implements LogoutRepository {
  async logout(): Promise<void> {
    // Solo limpiar store local (sin petición al servidor)
    useAuthStore.getState().logout();
  }
}

export const logoutLocalRepository = new LogoutLocalRepository();
